import React, { useState } from 'react';
import { withTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import { BackButton, Button, Input, Title, Collapsible } from '../../../components/UI/ComponentsUI';
import StockService from '../../../services/StockService';
import { onValueChange, validateInputsRequired } from "../../../utils/handleChangeHooks";
import { closeCollapsible, isNullOrEmpty, translate } from '../../../utils/util';
import { createAndSaveWorkbookMerge, createSheetToJson } from '../../../utils/worksheetUtil';

const BalancePartNumberStored = (props) => {
    const [filterSearch, setFilterSearch] = useState({
        areas: [],
        areaFilter: '',
        areaXd: true,
        partNumber: props.filter?.partNumber || ''
    })

    const [summary, setSummary] = useState()

    const onChange = (event) => {
        onValueChange(event, filterSearch, setFilterSearch);
    };

    const searchSummary = () => {
        if (validateInputsRequired('formInput')) {
            let filterModal = {};
            Object.assign(filterModal, filterSearch);
            if (filterModal.areas.length === 0 && !isNullOrEmpty(filterModal.areaFilter)) {
                filterModal.areas = [filterModal.areaFilter]
            }
            props.GetBalancePartNumberStored(filterModal, (data) => {
                if (data) {
                    setSummary(data);
                    closeCollapsible("collapsibleBalance");
                }
                else {
                    setSummary([]);
                }
            });
        }
    }

    const exportExcel = () => {
        try {
            var dataExportstatusPhysical = [];
            var dataExportstatusLogical = [];
            var dataExport = [];

            var headerPhysical = formatHeader(summary?.itemsArea.map((f) => f.statusPhysical));
            var headerLogical = formatHeader(summary?.itemsArea.map((f) => f.statusLogical));

            for (let index = 0; index < summary.itemsArea.length; index += 1) {
                var itemArea = summary.itemsArea[index]
                var objPush = {
                    'DESENHO': summary?.partNumber || '',
                    'AREA': itemArea?.area || '',
                    'QTD. AREA': itemArea?.quantity || '',
                }

                //STATUS FISICO
                var statusPhysical = itemArea?.statusPhysical;
                var valuePhysical = formatValue(statusPhysical, headerPhysical, true);

                var objPushStatus = {
                    'AREA': itemArea?.area || '',
                }
                const obj = JSON.parse(`[${valuePhysical.join()}]`);
                for (let index = 0; index < obj.length; index += 1) {
                    objPushStatus = {
                        ...objPushStatus,
                        ...obj[index]
                    }
                }

                //STATUS LOGICO
                var statusLogical = itemArea?.statusLogical;
                var valueLogical = formatValue(statusLogical, headerLogical, true);

                var objPushStatusLogical = {
                    'AREA': itemArea?.area || '',
                }
                const obj2 = JSON.parse(`[${valueLogical.join()}]`);
                for (let index = 0; index < obj2.length; index += 1) {
                    objPushStatusLogical = {
                        ...objPushStatusLogical,
                        ...obj2[index]
                    }
                }

                dataExport.push(objPush);
                dataExportstatusLogical.push(objPushStatusLogical);
                dataExportstatusPhysical.push(objPushStatus)
            }

            var data = createSheetToJson(dataExport);
            const data2 = [
                ['STATUS FÍSICO', ""]
            ];
            var data3 = createSheetToJson(dataExportstatusPhysical);

            const data4 = [
                ['STATUS LÓGICO', ""]
            ];
            var data5 = createSheetToJson(dataExportstatusLogical);

            const data6 = [
                ['PENDENTE CONFERENCIA FISICA ', summary.totalPhysicalConfirmation],
                ['TOTAL DESENHO ARMAZEM', summary.totalAreaBalance] // cabeçalhos
            ];

            const datas = [data, data2, data3, data4, data5, data6];
            createAndSaveWorkbookMerge(datas, "saldo_desenho.xlsx");
        } catch (error) {
            console.error(error);
        }

    }

    const addAreaFilter = () => {
        if (!isNullOrEmpty(filterSearch.areaFilter) && !filterSearch.areas.find(f => f === filterSearch.areaFilter)) {
            filterSearch.areas.push(filterSearch.areaFilter);
            filterSearch.areaFilter = ""
            setFilterSearch({ ...filterSearch })
        }
        document.getElementById("areaFilter").focus()
    }

    const removedAreaFilter = (area) => {
        if (!isNullOrEmpty(area)) {
            filterSearch.areas = filterSearch.areas.filter(f => f !== area);
            setFilterSearch({ ...filterSearch })
        }
    }

    const formatHeader = (data, excel) => {
        var header = [];

        if (excel) {
            data.forEach(element => {
                if (!header.find(f => f === element.status)) {
                    header.push(element.status)
                }
            });
        } else {
            data.forEach(a => {
                a.forEach((element) => {
                    if (!header.find(f => f === element.status)) {
                        header.push(element.status)
                    }
                })
            });
        }
        return header;
    }

    const formatValue = (data, header, excel) => {
        var value = [];
        var arrayJson = [];

        if (excel) {
            for (let i = 0; i < header.length; i += 1) {
                const aux = header[i];
                arrayJson.push(`{"${aux}":"${((data && data.find((f) => f.status === aux)?.quantity) || 0)}"}`)
            }
            return arrayJson

        }
        for (let index = 0; index < data.length; index += 1) {
            const areaStatus = data[index];
            let arrayAux = []
            for (let i = 0; i < header.length; i += 1) {
                const aux = header[i];
                arrayAux.push((areaStatus && areaStatus.find((f) => f.status === aux)?.quantity) || 0);

            }

            value.push(arrayAux);
        }
        return value
    }

    const renderTableArea = () => {
        return (<div className="col s12 m3 l3">
            <div style={{ textAlign: 'center' }}>
                <b className="sixth-text-color block" style={{ textAlign: 'center' }}>ESTOQUE</b>
            </div>

            <table className='striped'>
                <thead>
                    <tr>
                        <th style={{ textAlign: 'center' }}>AREA</th>
                        <th style={{ textAlign: 'center' }}>TOTAL PEÇAS</th>
                    </tr>
                </thead>
                <tbody>
                    {
                        summary?.itemsArea.map((item) => {
                            return (
                                <>
                                    <tr>
                                        <td style={{ textAlign: 'center' }}>{item.area}</td>
                                        <td style={{ textAlign: 'center' }}>{item.quantity}</td>
                                    </tr>
                                </>
                            )
                        })
                    }
                </tbody>
            </table>
        </div>);
    }

    const renderTablePhysical = () => {
        var statusPhysical = summary?.itemsArea.map((f) => f.statusPhysical);
        var header = formatHeader(statusPhysical);
        var value = formatValue(statusPhysical, header);

        return (<div className="col s12 m5 l5">
            <div style={{ textAlign: 'center' }}>
                <b className="sixth-text-color block" style={{ textAlign: 'center' }}>STATUS FÍSICO</b>
            </div>
            <table className='striped'>
                <thead>
                    <tr>
                        {
                            header.map((f) => {
                                return (
                                    <th style={{ textAlign: 'center' }}> {f} </th>
                                )
                            })
                        }
                    </tr>
                </thead>
                <tbody>
                    {
                        value.map((f) => {
                            return (
                                <tr>
                                    {
                                        f.map((fa) => {
                                            return (
                                                <td style={{ textAlign: 'center' }}> {fa} </td>

                                            )
                                        })
                                    }
                                </tr>)

                        })
                    }
                </tbody>
            </table>
        </div>)
    }

    const renderTableLogical = () => {
        var statusLogical = summary?.itemsArea.map((f) => f.statusLogical);
        var header = formatHeader(statusLogical);
        var value = formatValue(statusLogical, header);

        return (<div className="col s12 m4 l4">
            <div style={{ textAlign: 'center' }}>
                <b className="sixth-text-color block" style={{ textAlign: 'center' }}>STATUS LÓGICO</b>
            </div>
            <table className='striped'>
                <thead>
                    <tr>
                        {
                            header.map((f) => {
                                return (
                                    <th style={{
                                        textAlign: 'center',
                                        wordWrap: 'break-word',
                                        whiteSpace: 'normal'
                                    }}> {f} </th>
                                )
                            })
                        }
                    </tr>
                </thead>
                <tbody>
                    {
                        value.map((f) => {
                            return (
                                <tr>
                                    {
                                        f.map((fa) => {
                                            return (
                                                <td style={{ textAlign: 'center' }}> {fa} </td>

                                            )
                                        })
                                    }
                                </tr>)

                        })
                    }
                </tbody>
            </table>
        </div>)
    }

    return (
        <div>
            <BackButton {...props} />
            <Title label="Saldo Desenho Armazenado" />
            <div className="container" >
                <Collapsible
                    id="collapsibleBalance"
                    header={translate('stock:filter')}
                    body={
                        <>
                            <div id="formInput" className="row no-margin-bottom">
                                <div className="row">
                                    <div className="input-field no-padding col s11 m6 l6">
                                        <Input
                                            id="partNumber"
                                            name='partNumber'
                                            label={translate('stock:partnumber')}
                                            type="text"
                                            numericonly="true"
                                            maxLength={11}
                                            required
                                            defaultValue={filterSearch.partNumber || ''}
                                            onChange={onChange}
                                        />
                                    </div>
                                    <div className="input-field no-padding col s10 m4 l4">
                                        <Input
                                            id="areaFilter"
                                            name='areaFilter'
                                            label={translate('stock:area')}
                                            type="text"
                                            maxLength={19}
                                            value={filterSearch.areaFilter || ''}
                                            onChange={onChange}
                                        />
                                    </div>

                                    <div className="col s1" style={{ paddingTop: '15px' }}>
                                        <button
                                            className="btn-floating btn-Small btn-principal waves-effect waves-light"
                                            type="button"
                                            onClick={() => {
                                                addAreaFilter()
                                            }}
                                        >
                                            <i className={`mdi mdi mdi-plus`} />
                                        </button>
                                    </div>
                                </div>
                                <div className="row">
                                    {filterSearch.areas.length > 0 &&
                                        <div>
                                            {filterSearch.areas?.map((i, index) => (
                                                <div className="col s4" key={index} style={{ display: 'flex', flex: 1, alignItems: 'center', padding: 4, margin: 2, border: 'solid', borderWidth: 1, width: 'auto', borderRadius: 6 }}>
                                                    <i className={'mdi mdi-close-circle-outline posfix'} style={{ top: '0rem', fontSize: 20 }} onClick={() => removedAreaFilter(i)} />
                                                    <span style={{ marginLeft: 6 }}>{i}</span>
                                                </div>
                                            ))}
                                        </div>}
                                </div>
                            </div>
                            <div className="row" style={{ paddingTop: '5px' }}>
                                <Button
                                    full="true"
                                    className="col s6 btn-principal"
                                    text={translate('general:search')}
                                    onClick={searchSummary}
                                />
                            </div>
                        </>
                    }
                />
            </div>
            <div className="" style={{ backgroundColor: 'white', width: '100%', overflowX: 'scroll', whiteSpace: 'nowrap' }}>
                {summary &&
                    <div>
                        <div className="row">
                            <div className="col s12">
                                <b id={`${summary?.partNumber}`} className="sixth-text-color block" style={{ display: 'block', paddingBlockEnd: '20px' }}>
                                    {summary?.partNumber} - {summary?.partNumberDescription}
                                </b>
                            </div>
                            {renderTableArea()}
                            {renderTablePhysical()}
                            {renderTableLogical()}
                            <br />
                            <br />
                            <div className="col s12">
                                <b className="sixth-text-color block" style={{ paddingLeft: '10px' }}>
                                    PENDENTE CONFERENCIA FISICA {summary.totalPhysicalConfirmation} PEÇAS</b>
                            </div>
                            <div className="col s12">
                                <b className="sixth-text-color block" style={{ paddingLeft: '10px' }}>
                                    TOTAL DESENHO ARMAZEM {summary.totalAreaBalance} PEÇAS</b>
                            </div>
                        </div>
                        <div className="row">
                            <div className="input-field no-padding col s6 ">
                                <i className="mdi mdi-36px mdi-file-excel" style={{ cursor: 'pointer' }} onClick={exportExcel}></i>
                            </div>
                        </div>
                    </div>
                }
            </div>
        </div>
    );
}

const mapStateToProps = (state) => {
    return {
        user: state.userReducer.user,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        GetBalancePartNumberStored: (filter, callback) => {
            dispatch(StockService.GetBalancePartNumberStored(filter, callback));
        }
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()(BalancePartNumberStored));